import React from 'react';
interface StickyNoteProps {
  children: React.ReactNode;
  color?: 'pink' | 'yellow' | 'cream';
  rotation?: 1 | 2 | 3 | 4 | 5;
  className?: string;
}
export function StickyNote({
  children,
  color = 'pink',
  rotation = 1,
  className = ''
}: StickyNoteProps) {
  const colorClasses = {
    pink: 'bg-brand-pink-100 text-brand-pink-900',
    yellow: 'bg-cream-200 text-gray-900',
    cream: 'bg-cream-100 text-gray-900'
  };
  return <div className={`inline-block px-4 py-2 rounded-lg shadow-md font-bold text-xs md:text-sm uppercase sticky-note-rotate-${rotation} ${colorClasses[color]} ${className}`} data-id="element-206">
      {children}
    </div>;
}